import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const textBoxImg = require('../../assets/textbox.png').default;
const pictureImg = require('../../assets/picture.png').default;
const signatureImg = require('../../assets/signatura.png').default;
const rectangleImg = require('../../assets/rectangle.png').default;
const ellipseImg = require('../../assets/ellipse.png').default;
const lineImg = require('../../assets/line.png').default;
const wordImg = require('../../assets/word.png').default;
const tableImg = require('../../assets/table.png').default;
type Props = {
    title: string,
    icon: string,
    properties: {},
    type: string
};

class Tool extends React.Component<Props> {
    componentDidMount = () => {
        const imgTextBox = new Image();
        imgTextBox.src = textBoxImg;
        imgTextBox.onload = () => this.setState({dragImgTextBox: imgTextBox});
        const imgPicture = new Image();
        imgPicture.src = pictureImg;
        imgPicture.onload = () => this.setState({dragImgPicture: imgPicture});
        const imgSignature = new Image();
        imgSignature.src = signatureImg;
        imgSignature.onload = () => this.setState({dragImgSignature: imgSignature});
        const imgRectangle = new Image();
        imgRectangle.src = rectangleImg;
        imgRectangle.onload = () => this.setState({dragImgRectangle: imgRectangle});
        const imgEllipse = new Image();
        imgEllipse.src = ellipseImg;
        imgEllipse.onload = () => this.setState({dragImgEllipse: imgEllipse});
        const imgLine = new Image();
        imgLine.src = lineImg;
        imgLine.onload = () => this.setState({dragImgLine: imgLine});
        const imgWord = new Image();
        imgWord.src = wordImg;
        imgWord.onload = () => this.setState({dragImgWord: imgWord});
        const imgSlider = new Image();
        imgSlider.src = wordImg;
        imgSlider.onload = () => this.setState({dragImgSlider: imgSlider});
        const imgTable = new Image();
        imgTable.src = tableImg;
        imgTable.onload = () => this.setState({dragImgTable: imgTable});
    };
    onDragStart = (e: Object) => {
        const {properties, title, type} = this.props;
        switch (type) {
            case "TextBox":
                e.dataTransfer.setDragImage(this.state.dragImgTextBox, 51, 10);
                break;
            case "Picture":
                e.dataTransfer.setDragImage(this.state.dragImgPicture, 50, 10);
                break;
            case "Signature":
                e.dataTransfer.setDragImage(this.state.dragImgSignature, 25, 10);
                break;
            case "Rectangle":
                e.dataTransfer.setDragImage(this.state.dragImgRectangle, 50, 10);
                break;
            case "Ellipse":
                e.dataTransfer.setDragImage(this.state.dragImgEllipse, 50, 10);
                break;
            case "Lines":
                e.dataTransfer.setDragImage(this.state.dragImgLine, 50, 10);
                break;
            case "Word":
                e.dataTransfer.setDragImage(this.state.dragImgWord, 50, 10);
                break;
            case "Slider":
                e.dataTransfer.setDragImage(this.state.dragImgSlider, 151, 10);
                break;
            case "Table":
                e.dataTransfer.setDragImage(this.state.dragImgTable, 50, 25);
                break;
            case "Chart":
                // FIX-CHART: Use Table image as drag preview (no dedicated chart asset yet)
                e.dataTransfer.setDragImage(this.state.dragImgTable, 50, 25);
                break;
        }
        e.dataTransfer.setData(
            'tool',
            JSON.stringify({
                title,
                properties,
                type
            })
        );
    };
    render = () => {
        const {icon, title} = this.props;
        return (
            <div id="drag-with-image"
                 onDragStart={this.onDragStart}
                 className="pl-4 hover:bg-blue-50 p-2 bg-gray-50 w-full text-gray-600 border-b border-gray-200 text-sm outline-none whitespace-nowrap"
                 draggable
            >
                <FontAwesomeIcon className="text-gray-600 mr-2" icon={icon}/>
                {title}
            </div>
        );
    };
}

export default Tool;
